import type { MapLook } from "../types.ts";
import { inkedClouds, skyDome } from "../sky.ts";
import { paintPanels } from "./panels.ts";
import { tramPayload, tramTrack } from "./tram.ts";

/**
 * Brussels in ligne claire: flat colour, one ink line, a clear album-cyan sky with inked cumulus.
 * The sun stands in the south-west, so the facades you face while pushing (west and south) are lit.
 */
export const BRUSSELS: MapLook = {
  sky: { top: "#79bddb", horizon: "#e3f1ec" },
  fog: { color: "#dcece9", density: 0.0032 },
  // The sky light is cool, so faces out of the sun take a colourist's blue-grey shade.
  hemi: { intensity: 0.82, sky: "#dbe6f4", ground: "#a19d97", dir: [0.1, 1, 0.05] },
  // Low south-western sun (36°): lit facades and lit ground come out about equally bright.
  sun: { dir: [0.572, -0.588, -0.572], intensity: 0.95, color: "#fff1d8" },
  shadowDarkness: 0.5,
  ink: { color: "#1a1c24", width: 4 },
  glow: 0.5,
  dress: (ctx) => [skyDome(ctx.scene, ctx.glow, BRUSSELS.sky.top, BRUSSELS.sky.horizon!), ...inkedClouds(ctx.scene, ctx.glow, ctx.ink, { seed: 1831 }), ...paintPanels(ctx)],
  track: tramTrack,
  payload: tramPayload,
  // Up the hill from over the lower town: gilded gables, the spire, the Galeries, the Palais dome.
  showcase: { target: [-25, 5, -35], radius: 147.6, alpha: 1.043, beta: 1.225, fov: 0.8, sweep: 0.3 },
};
